

export const VIEWCONSTANT = {
    NewRegistrationNikshay: 'New Registration Nikshay',
    ViewNikshayDetails: 'View Nikshay Details',
    AddTestNikshay: 'Add Nikshay Test',
    AddNewPateint: 'Add New Patient',
    DialysisHistory: 'Dialysis History',
    medicalHistory: 'Medical History',
    DiseaseManagement: 'Disease Management',
    Vaccinationuwin: 'Uwin Vaccination',
    Linkedchildren: 'Linked Children',
}